var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMapNb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 37,
    viewBox: "0 0 29 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0.0515332C6.49174 0.0515332 0 6.33844 0 14.094C0 14.094 0 14.094 0 14.1198C0 14.8155 0.0532109 15.5111 0.159633 16.1811C0.478899 18.2681 1.27706 20.2006 2.4211 21.8753C2.9266 22.5968 3.48532 23.2667 4.12385 23.8851L7.31651 27.6727L7.60917 28.0334L15.1119 37L21.7101 28.1623V28.0334H21.8165L24.9826 23.782C25.9138 22.8287 26.7119 21.7723 27.3505 20.587C28.2018 18.9896 28.7605 17.2375 28.9468 15.3565C29 14.9443 29 14.5063 29 14.0682C29 14.0682 29 14.0682 29 14.0425C29 6.28691 22.5083 0 14.5 0V0.0515332Z",
    fill: "#FFE926"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1491 13.5872L16.1316 19H19V9H15.8441V14.4676L11.783 9H9V19H12.1491V13.5872Z",
    fill: "#241716"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapNb);
export default __webpack_public_path__ + "static/media/icon_map_nb.704a2ad08a07d88dec313695159576c0.svg";
export { ForwardRef as ReactComponent };